var chunkToChildrenMap = {
	"9740": [
		9594,
		3982,
		3381,
		1793,
		7705,
		2009,
		866
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));